<section class="section-beneficios zoom-scope" [ngStyle]="styles">
    <div class="benefits-container">
        <!-- LADO ESQUERDO: TEXTO E BOTÃO -->
        @if(title != ' '){
        <div class="benefits-left">
          <h1 class="benefits-title" [innerHTML]="title"></h1>
          <div class="mt-4">
            <button class="btn-quero-ser-socio" routerLink="/cadastro-socio">
              QUERO SER SÓCIO
            </button>
          </div>
        </div>
        } @else {
          <div class="benefits-left-no-title">
          <div class="margin-btn">
            <button class="btn-quero-ser-socio" routerLink="/cadastro-socio">
              QUERO SER SÓCIO
            </button>
          </div>
        </div>
        }


        <!-- LADO DIREITO: CARROSSEL -->
        <div class="benefits-right">
            <div class="benefits-carousel-wrapper" #carouselContainer [class.few-items]="items.length <= 3">
                <div class="benefit-card-container" *ngFor="let item of items">
                    <div class="benefit-card" (click)="openLink(item)">
                        <div class="benefit-image-wrapper">
                            <img [src]="item.src" alt="{{item.title}}" class="benefit-image">
                        </div>
                        <div class="benefit-info">
                            <h3 class="benefit-card-title">{{item.title}}</h3>
                            <span class="more-info">MAIS INFORMAÇÕES</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- CONTROLES DO CARROSSEL -->
            <div class="carousel-nav-buttons" *ngIf="items.length > 3">
                <button class="nav-btn prev" (click)="scrollCarousel('prev')">
                    <i class="bi bi-chevron-left"></i>
                </button>
                <button class="nav-btn next" (click)="scrollCarousel('next')">
                    <i class="bi bi-chevron-right"></i>
                </button>
            </div>
        </div>
    </div>
</section>
